(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('environmentController', Controller);
    Controller.$inject = [
        '$cookies',
        '$timeout',
        'Routing'
    ];

    function Controller (
        $cookies,
        $timeout,
        Routing
    ) {

        var vm = this;
        var OFFICE_SOFTWARE_COOKIE_NAME = "office-software";
        vm.showInstructions = false;

        vm.officeSoftwareOptions = [
            { value: 'ms-office2007', text: 'MS Office 2007 or older' },
            { value: 'ms-office2010', text: 'MS Office 2010 or newer' }
        ];

        vm.officeSoftware = _.find(
            vm.officeSoftwareOptions,
            { value: $cookies.get(OFFICE_SOFTWARE_COOKIE_NAME) }
        ) || vm.officeSoftwareOptions[0];


        vm.onOfficeChange = function() {
            vm.checkShowInstructions();
        };

        vm.checkShowInstructions = function() {
            vm.showInstructions = false;
            if(vm.officeSoftware.value == 'ms-office2010')
            {
                vm.showInstructions = true;
            }
        };

        vm.message = '';

        vm.onSubmit = function() {
            if (vm.officeSoftware) {
                var expDate = new Date();
                expDate.setDate(expDate.getDate() + 365);

                $cookies.put(OFFICE_SOFTWARE_COOKIE_NAME, vm.officeSoftware.value, {path: '/', expires: expDate});
                vm.message = 'Your selection has been saved.';

                $timeout(function () {
                    vm.message = '';
                }, 2000);
            }
        };



        vm.onCancel = function() {
            Routing.start();
        };



        //----------- initialization ------------------

        function init() {
            vm.checkShowInstructions();
        }


        init();


    }



})();
